import {z} from "zod";

//DIRECTOR > TEAM_LEADER > SENIOR_MANAGER > PART_TIME > PART_TIME
export const AUTHORITY = {
	PART_TIME: "PART_TIME", // 파트타임
	MANAGER: "MANAGER", // 매니저
	TEAM_LEADER: "TEAM_LEADER", // 팀장
	DIRECTOR: "DIRECTOR", // 이사
	SENIOR_MANAGER: "SENIOR_MANAGER" // 본부장
} as const;

export const AUTHORITY_ENUM = z.enum(Object.keys(AUTHORITY) as [keyof typeof AUTHORITY]);
export type AUTHORITY = z.infer<typeof AUTHORITY_ENUM>;

export const schema = z.object({
	externalId: z.string(),
	name: z.string(),
	position: z.string(),
	department: z.string(),
	authority: AUTHORITY_ENUM
});

const model = schema.transform((values) => ({
	...values
}));

export const EmployeeModel = {schema, model};
export type IEmployeeModel = z.infer<typeof EmployeeModel.model>;
export const DEFAULT_EMPLOYEE: IEmployeeModel = {
	externalId: "",
	name: "",
	position: "",
	department: "",
	authority: "PART_TIME"
};
